/* eslint-disable eqeqeq */
import React, { useEffect } from "react";
import { Select } from "@rmwc/select";
import EditPriceItem from "../../EditPriceItem/EditPriceItem";
import { Tab, Nav } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CenterWall from "./CenterWall/CenterWall";
import RightWall from "./RightWall/RightWall";
import LeftWall from "./LeftWall/LeftWall";
import FrontLeantoWalls from "./FrontLeantoWalls/FrontLeantoWalls";
import BackLeantoWalls from "./BackLeantoWalls/BackLeantoWalls";
import CurrencyFormat from "react-currency-format";
import { handleActiveWallSubTab, handleShowOverlay, toggleAllVerticalCheckboxChange } from "../../../action";
import { getBuildingName } from "../../../redux/reducers/utils";



const Walls = () => {
	const const_var = useSelector((state) => state.reducer.const_var);
	const selectedLeanType = useSelector((state) => state.reducer.const_var.selectedLeanType);
	const isLTBuilding = useSelector((state) => state.reducer.const_var.isLTBuilding);

	const params = useSelector((state) => state.reducer.params);
	const dispatch = useDispatch();
	const [isNavKey, setIsNavKey] = React.useState("0");

	const setWallNavtab = (key) => {
		setIsNavKey(key);
	};

	const getActiveTab = (tabid, tabname) => {
		dispatch(handleActiveWallSubTab(tabname));
		let goTo = document.getElementById(tabid);
		let container = document.querySelector(".walltype-nav");

		let activeTabPosition = goTo.offsetLeft + goTo.offsetWidth;
		let containerScroll = container.scrollLeft + container.offsetWidth;
		if (activeTabPosition > containerScroll) {
			// container.scrollLeft = container.offsetWidth + goTo.offsetWidth
			let moveTo = container.offsetWidth + goTo.offsetWidth;
			container.scrollTo({ left: moveTo, behavior: "smooth" });
		}
		if (goTo.offsetLeft < container.scrollLeft) {
			// container.scrollLeft = container.scrollLeft - goTo.offsetWidth
			let moveTo = container.scrollLeft - goTo.offsetWidth;
			container.scrollTo({ left: moveTo, behavior: "smooth" });
		}
	};

	const toggleDropdown = () => {
		const app = document.getElementsByClassName("App")[0];
		if (app.classList.contains("activeToggle")) {
			app.classList.remove("activeToggle");
			dispatch(handleShowOverlay(false));
		} else {
			app.classList.add("activeToggle");
			dispatch(handleShowOverlay(true));
		}
	};

	const sidingOptions = const_var.sidingOptions;

	const orientationOptions = const_var.sidingOrientationOptions;

	const hideOrientation = const_var.crmSetting.is_Edit && const_var.selSidingOption != "metal" && const_var.selSidingObj?.panel_orientation?.length == 0;

	const shouldShowLeanOption = (leanType) => {
		if (params[`add_${leanType}_lean`] == true) {
			if (isLTBuilding) {
				if (selectedLeanType === "") {
					if (params.leanStyle[leanType] === "standard") {
						return true;
					}
					return false;
				} else {
					if (selectedLeanType === leanType) {
						return true;
					}
					return false;
				}
			}
			return true;
		}
		return false;
	};

	const shouldShowCenterBuildingOption = () => {
		if (isLTBuilding) {
			if (selectedLeanType === "") {
				return true;
			}
			return false;
		}
		return true;
	};

	useEffect(() => {
		let activeTab = "0", tabId = "tab21";
		if (selectedLeanType === 'left') {
			activeTab = "1"; // Left lean-to
			tabId = "tab22";
		} else if (selectedLeanType === 'right') {
			activeTab = "2"; // Right lean-to
			tabId = "tab23";
		} else if (selectedLeanType === 'front') {
			activeTab = "3"; // Front lean-to
			tabId = "tab24";
		} else if (selectedLeanType === 'back') {
			activeTab = "4"; // Back lean-to
			tabId = "tab25";
		}
		if(selectedLeanType !== "") {
			setIsNavKey(activeTab);
			getActiveTab(tabId, `${selectedLeanType}_lean_to`);              
		} else {
				setIsNavKey("0");
			getActiveTab("tab21", "center_building");         
		}
	}, [selectedLeanType]);
	return (
		<div className="building-elements-sec wals-tab-detail">
			<div className="building-elements-sec-mid pt-0">
				{const_var.mainSidingOptions && const_var.mainSidingOptions.length > 0 && (
					<div className="row pl-3 pr-3">
						<div
							className={
								"form-group " +
								((const_var.selSidingOption == "metal" || params.wallOrientation != "") &&
								!hideOrientation &&
								!const_var.selSidingOption.includes("horizontal") &&
								!const_var.selSidingOption.includes("vertical")
									? "col-md-8"
									: "col-md-12")
							}
						>
							<label className="control-label">
								Siding Material
								{const_var.selSidingObj && const_var.selSidingObj.name == const_var.selSidingOption && const_var.selSidingObj.price_type == "%" && (
									<>
										{const_var.loginSession == true ? (
											<aside className="price-box v-center">
												<EditPriceItem
													jsonObjValue={const_var.post_data.building != undefined && const_var.post_data.building.siding_material_price ? const_var.post_data.building.siding_material_price : 0}
													jsonObjKey="siding_material_price"
												/>
											</aside>
										) : (
											<div className="price-box-type-2">
												{const_var.hide_price_calculation != 1 &&
													const_var.loginSession == false &&
													const_var.post_data.building !== undefined &&
													const_var.post_data.building.siding_material_price !== 0 && (
														<CurrencyFormat value={const_var.post_data.building.siding_material_price} displayType={"text"} thousandSeparator={true} prefix={"$"} />
													)}
											</div>
										)}
									</>
								)}
							</label>
							<div className="floating-label-input">
								<Select onChange={(e) => dispatch(toggleAllVerticalCheckboxChange(e.target.value))} value={const_var.selSidingOption} options={sidingOptions} />
							</div>
						</div>
						<div
							className={`form-group col-md-4 pl-0 ${(const_var.selSidingOption == "metal" || params.wallOrientation != "") && !hideOrientation && !const_var.selSidingOption.includes("horizontal") && !const_var.selSidingOption.includes("vertical") ? "" : "d-none"}`}
						>
							<label className="control-label">Orientation</label>
							<div className="floating-label-input orientation-options">
								<Select
									className={const_var.checkVerticalCheckBox ? "disabled" : ""}
									onChange={(e) => dispatch(toggleAllVerticalCheckboxChange(const_var.selSidingOption, params.wallOrientation == "vertical" ? "horizontal" : "vertical"))}
									value={params.wallOrientation}
									options={orientationOptions}
								/>
							</div>
						</div>
					</div>
				)}
				<div className="building-elements-sec-mid-scroll">
					<form>
						<div className="section-seprator">
							<Tab.Container activeKey={isNavKey}>
								<Nav variant="tabs" className="nav-tab-default walltype-nav">
									{shouldShowCenterBuildingOption() && (
										<Nav.Item className="nav-item-default" id="tab21">
											<Nav.Link
												eventKey="0"
												className="nav-link-default"
												onSelect={(e) => {
													setWallNavtab(e);
													getActiveTab("tab21", "center_building");
												}}
											>
												Center Building
											</Nav.Link>
										</Nav.Item>
									)}

									{shouldShowLeanOption("left") ? (
										<Nav.Item className="nav-item-default" id="tab22">
											<Nav.Link
												eventKey="1"
												className="nav-link-default"
												onSelect={(e) => {
													setWallNavtab(e);
													getActiveTab("tab22", "left_lean_to");
												}}
											>
												{getBuildingName('left')}
											</Nav.Link>
										</Nav.Item>
									) : null}
									{shouldShowLeanOption("right") ? (
										<Nav.Item className="nav-item-default" id="tab23">
											<Nav.Link
												eventKey="2"
												className="nav-link-default"
												onSelect={(e) => {
													setWallNavtab(e);
													getActiveTab("tab23", "right_lean_to");
												}}
											>
												{getBuildingName('right')}
											</Nav.Link>
										</Nav.Item>
									) : null}
									{shouldShowLeanOption("front") ? (
										<Nav.Item className="nav-item-default" id="tab24">
											<Nav.Link
												eventKey="3"
												className="nav-link-default"
												onSelect={(e) => {
													setWallNavtab(e);
													getActiveTab("tab24", "front_lean_to");
												}}
											>
												{getBuildingName('front')}
											</Nav.Link>
										</Nav.Item>
									) : null}
									{shouldShowLeanOption("back") ? (
										<Nav.Item className="nav-item-default" id="tab25">
											<Nav.Link
												eventKey="4"
												className="nav-link-default"
												onSelect={(e) => {
													setWallNavtab(e);
													getActiveTab("tab25", "back_lean_to");
												}}
											>
												{getBuildingName('back')}
											</Nav.Link>
										</Nav.Item>
									) : null}
								</Nav>

								{isLTBuilding ? (
									<>
										{selectedLeanType === "" ? (
											<TabContentPro toggleDropdown={toggleDropdown} />
										) : (
											<>
												<div className="card-body-inner" style={{ paddingTop: "20px" }}>
													{selectedLeanType === "left" && <LeftWall toggleDropdown={toggleDropdown} />}
													{selectedLeanType === "right" && <RightWall toggleDropdown={toggleDropdown} />}
													{selectedLeanType === "front" && <FrontLeantoWalls toggleDropdown={toggleDropdown} />}
													{selectedLeanType === "back" && <BackLeantoWalls toggleDropdown={toggleDropdown} />}
												</div>
												<div className='storage-info-sec'>Certification changes can affect leg spacing, which may automatically reset the storage position.</div>
											</>
										)}
									</>
								) : (
									<>
										{" "}
										<TabContentPro toggleDropdown={toggleDropdown} />{" "}
									</>
								)}
							</Tab.Container>
						</div>
					</form>
				</div>
			</div>
		</div>
	);
};

const TabContentPro = ({ toggleDropdown }) => {
	const params = useSelector((state) => state.reducer.params);
	return (
		<Tab.Content className="tab-content-default">
			<Tab.Pane className="tab-pane-default" eventKey="0">
				<div className="card-body-inner">
					<CenterWall toggleDropdown={toggleDropdown} />
				</div>
               <div className='storage-info-sec'>Certification changes can affect leg spacing, which may automatically reset the storage position.</div>
			</Tab.Pane>

			{params.add_left_lean == true ? (
				<Tab.Pane className="tab-pane-default" eventKey="1">
					<div className="card-body-inner">
						<LeftWall toggleDropdown={toggleDropdown} />
					</div>
                  <div className='storage-info-sec'>Certification changes can affect leg spacing, which may automatically reset the storage position.</div>
				</Tab.Pane>
			) : null}
			{params.add_right_lean == true ? (
				<Tab.Pane className="tab-pane-default" eventKey="2">
					<div className="card-body-inner">
						<RightWall toggleDropdown={toggleDropdown} />
					</div>
                  <div className='storage-info-sec'>Certification changes can affect leg spacing, which may automatically reset the storage position.</div>
				</Tab.Pane>
			) : null}
			{params.add_front_lean == true ? (
				<Tab.Pane className="tab-pane-default" eventKey="3">
					<div className="card-body-inner">
						<FrontLeantoWalls toggleDropdown={toggleDropdown} />
					</div>
                  <div className='storage-info-sec'>Certification changes can affect leg spacing, which may automatically reset the storage position.</div>
				</Tab.Pane>
			) : null}
			{params.add_back_lean == true ? (
				<Tab.Pane className="tab-pane-default" eventKey="4">
					<div className="card-body-inner">
						<BackLeantoWalls toggleDropdown={toggleDropdown} />
					</div>
                  <div className='storage-info-sec'>Certification changes can affect leg spacing, which may automatically reset the storage position.</div>
				</Tab.Pane>
			) : null}
		</Tab.Content>
	);
};

export default Walls;
